module.exports = __webpack_public_path__ + "img/story030.89aca728.png";